export default __webpack_public_path__ + "static/media/dev-avan-java.bc99acca.png";